import React from 'react';
import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';
import { Calendar, Clock, User, Tag } from 'lucide-react';
import './AppointmentList.css';

const AppointmentList = ({ 
  appointments, 
  appointmentTypes, 
  workers, 
  onItemClick 
}) => {
  const { t } = useTranslation();

  // Sort appointments by date (newest first)
  const sortedAppointments = [...appointments].sort((a, b) => 
    new Date(b.start_time) - new Date(a.start_time)
  );

  // Get status badge class
  const getStatusClass = (status) => {
    switch (status) {
      case 'completed': return 'badge-success';
      case 'cancelled': return 'badge-error';
      case 'scheduled': return 'badge-info';
      default: return 'badge-info';
    }
  };

  // Get status label
  const getStatusLabel = (status) => {
    switch (status) {
      case 'completed': return t('appointments.completed');
      case 'cancelled': return t('appointments.cancelled');
      case 'scheduled': return t('appointments.scheduled');
      default: return status;
    }
  };

  if (appointments.length === 0) {
    return (
      <div className="card empty-state appointment-list-empty">
        <Calendar size={44} className="empty-icon" />
        <p>{t('appointments.noAppointments')}</p>
      </div>
    );
  }

  return (
    <div className="appointment-list">
      {sortedAppointments.map((apt) => {
        const aptType = appointmentTypes.find(t => t.id === apt.appointment_type_id);
        const worker = workers.find(w => w.id === apt.worker_id);
        
        return (
          <div 
            key={apt.id} 
            className="appointment-card card"
            onClick={() => onItemClick(apt)}
          >
            <div className="appointment-card-header">
              <div className="appointment-info">
                <h4 className="appointment-name">
                  {apt.name || t('appointments.customer')}
                </h4>
                <span className={`badge ${getStatusClass(apt.status)}`}>
                  {getStatusLabel(apt.status)}
                </span>
              </div>
            </div>
            
            <div className="appointment-card-body">
              <div className="appointment-detail">
                <Calendar size={16} />
                <span>
                  {format(parseISO(apt.start_time), 'PPP')}
                </span>
              </div>
              
              <div className="appointment-detail">
                <Clock size={16} />
                <span>
                  {format(parseISO(apt.start_time), 'p')} - {format(parseISO(apt.end_time), 'p')}
                </span>
              </div>
              
              {aptType && (
                <div className="appointment-detail">
                  <Tag size={16} />
                  <span>{aptType.name}</span>
                </div>
              )}
              
              {worker && (
                <div className="appointment-detail">
                  <User size={16} />
                  <span>{worker.name}</span>
                </div>
              )}
            </div>
            
            {apt.phone_number && (
              <div className="appointment-card-footer">
                <span className="phone-number">{apt.phone_number}</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AppointmentList;

